export default "__VITE_ASSET__DK0MpT_D__"